<template>
  <div>
    <a-modal
      width="1220px"
      v-model="isShow"
      centered
      :mask-closable="false"
      :ok-button-props="{ props: { loading: submitting } }"
      title="编辑"
      @ok="handleSubmit"
    >
      <a-form
        class="simiot-compact-form"
        :form="form"
        :label-col="{ span: 6 }"
        :wrapper-col="{ span: 16 }"
        @submit="handleSubmit"
      >
        <a-row>
          <a-col :span="12">
            <span class="item-title">基本信息</span>

            <a-form-item label="套餐名称">
              <a-input
                v-decorator="['name', {
                  normalize: this.$lodash.trim,
                  rules: [
                    { required: true, message: '请输入套餐名称' },
                    { max: 100, message: '最多100个字符' },
                  ]
                }]"
              />
            </a-form-item>

            <a-form-item label="运营商套餐ID">
              <a-input
                v-decorator="['carrier_package_id', {
                  normalize: this.$lodash.trim,
                  rules: [
                    { max: 100, message: '最多100个字符' },
                  ]
                }]"
              />
            </a-form-item>

            <a-form-item label="通用套餐名称">
              <a-select
                show-search
                :filter-option="filterOption"
                :loading="loadingBaseProducts"
                v-decorator="['base_carrier_product_id', {
                  rules: [
                    { required: true, message: '请选择通用套餐' },
                  ]
                }]"
                @change="changeBaseCarrierProduct"
              >
                <a-select-option
                  v-for="option in baseCarrierProductOptions"
                  :key="option.id"
                  :value="option.id"
                >
                  {{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>

            <a-form-item
              label="标签"
              class="simiot-display-item"
            >
              {{ data.tags_display }}
            </a-form-item>

            <a-form-item
              label="共享属性"
              class="simiot-display-item"
            >
              {{ data.traffic_share_property_display }}
            </a-form-item>

            <a-form-item
              label="服务周期"
              class="simiot-display-item"
            >
              {{ data.service_cycle_display }}
            </a-form-item>

            <a-form-item
              label="套餐容量"
              class="simiot-display-item"
              v-if="data.traffic_share_property !== 'backward'"
            >
              {{ data.package_capacity_display }}
            </a-form-item>

            <a-form-item
              label="语音"
              class="simiot-display-item"
            >
              {{ data.voice_capacity_display }}
            </a-form-item>

            <a-form-item label="流量属性">
              <a-radio-group
                v-decorator="['traffic_property',{
                  rules: [
                    { required: true, message: '请选择流量属性' },
                  ]
                }]"
              >
                <a-radio v-for="option in trafficPropertyOptions" :value="option.value" :key="option.value">
                  {{ option.label }}
                </a-radio>
              </a-radio-group>
            </a-form-item>

            <a-form-item label="套餐描述">
              <a-textarea
                :rows="3"
                v-decorator="[
                  'description',
                  {
                    rules: [{ max: 200, message: '最多200个字符' }],
                  },
                ]"
              />
            </a-form-item>
          </a-col>

          <a-col :span="12">
            <span class="item-title">价格设置</span>

            <a-form-item label="套餐价格" :required="!priceDisabled">
              <a-space>
                <a-input-number
                  style="width: 200px;"
                  :min="0"
                  :max="10000000"
                  :step="0.001"
                  :precision="3"
                  :disabled="priceDisabled"
                  v-decorator="['price', { rules: priceRules }]"
                />
                <span :class="{ 'field-disabled-text': priceDisabled }">{{ priceLabelUint }}</span>
              </a-space>
            </a-form-item>

            <a-form-item label="超额资费" :required="!ladderFeeEnabled">
              <a-input-group compact>
                <a-form-item :style="{ display: 'inline-block', width: '50%', marginBottom: 0 }">
                  <a-space>
                    <a-input-number
                      style="width: 110px"
                      :min="0"
                      :max="10000000"
                      :step="0.001"
                      :precision="3"
                      :disabled="ladderFeeEnabled"
                      v-decorator="['excess_price', { rules: excessPriceRules }]"
                    />
                    <span :class="{ 'field-disabled-text': ladderFeeEnabled }">元/</span>
                  </a-space>
                </a-form-item>

                <a-form-item :style="{ display: 'inline-block', width: '50%', marginBottom: 0 }">
                  <a-space>
                    <a-input-number
                      style="width: 110px"
                      :min="1"
                      :max="10000000"
                      :step="1"
                      :precision="0"
                      :disabled="ladderFeeEnabled"
                      v-decorator="['excess_price_quantity', { rules: excessPriceQuantityRules }]"
                    />
                    <span :class="{ 'field-disabled-text': ladderFeeEnabled }">{{ excessPriceQuantityLabelUnit }}</span>
                  </a-space>
                </a-form-item>
              </a-input-group>
            </a-form-item>

            <a-form-item label="月功能费">
              <a-space>
                <a-input-number
                  style="width: 200px;"
                  :min="0"
                  :max="10000000"
                  :step="0.001"
                  :precision="3"
                  v-decorator="['monthly_feature_fee', {
                    initialValue: 0
                  }]"
                />
                <span>元/月</span>
              </a-space>
            </a-form-item>

            <a-form-item label="GRE资费">
              <a-space>
                <a-input-number
                  style="width: 200px;"
                  :min="0"
                  :max="10000000"
                  :step="0.001"
                  :precision="3"
                  v-decorator="['gre_price', {
                    initialValue: 0
                  }]"
                />
                <span>元/GB</span>
              </a-space>
            </a-form-item>

            <a-form-item label="语音单价">
              <a-space>
                <a-input-number
                  style="width: 200px;"
                  :min="0"
                  :max="10000000"
                  :step="0.001"
                  :precision="3"
                  v-decorator="['voice_unit_price', {
                    initialValue: 0
                  }]"
                />
                <span>元/分钟</span>
              </a-space>
            </a-form-item>

            <a-form-item label="短信单价">
              <a-space>
                <a-input-number
                  style="width: 200px;"
                  :min="0"
                  :max="10000000"
                  :step="0.001"
                  :precision="3"
                  v-decorator="['sms_unit_price', {
                    initialValue: 0
                  }]"
                />
                <span>元/条</span>
              </a-space>
            </a-form-item>

            <a-form-item label="阶梯资费">
              <a-space>
                <a-checkbox
                  :checked="ladderFeeEnabled"
                  :disabled="!canEnableLadderFee"
                  @change="changeLadderFeeEnabled"
                >启用</a-checkbox>
                <a v-if="ladderFeeEnabled" @click="addLadderTier">添加档位</a>
              </a-space>
            </a-form-item>

            <template v-if="ladderFeeEnabled">
              <a-form-item
                v-for="(tier, index) in ladderFeeTiers"
                :key="'ladder-fee-' + index"
                :label="'档位' + (index + 1)"
              >
                <a-input-group compact>
                  <a-form-item :style="{ display: 'inline-block', width: '50%', marginBottom: 0 }">
                    <a-space>
                      <a-input-number
                        v-model="tier.upper_mb"
                        style="width: 110px"
                        :min="0"
                        :max="10000000"
                        :step="1"
                        :precision="3"
                      />
                      <span>{{ index === ladderFeeTiers.length - 1 ? 'MB以上' : 'MB以下' }}</span>
                    </a-space>
                  </a-form-item>

                  <a-form-item :style="{ display: 'inline-block', width: '50%', marginBottom: 0 }">
                    <a-space>
                      <a-input-number
                        v-model="tier.unit_price"
                        style="width: 110px"
                        :min="0"
                        :max="10000000"
                        :step="0.0001"
                        :precision="4"
                      />
                      <span>元/MB</span>
                      <a v-if="ladderFeeTiers.length > 1" @click="removeLadderTier(index)">删除</a>
                    </a-space>
                  </a-form-item>
                </a-input-group>
              </a-form-item>
            </template>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import { findCarrierProductForm, updateCarrierProduct } from '@/api/carrier_product'
import { findImportableBaseCarrierProducts } from '@/api/base_carrier_product'
import { findCarrierType } from '@/api/carrier_account'
import { findTrafficPropertyOptions } from '@/api/common_options'

export default {
  name: 'EditCarrierProduct',
  props: {
    visible: {
      type: Boolean,
      required: true
    },
    id: {
      type: Number,
      required: true
    },
    carrierAccountId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this, { name: 'carrier_product' }),
      submitting: false,
      data: {},
      capacityUnit: '',
      serviceCycle: 0,
      trafficShareProperty: '',
      trafficPropertyOptions: findTrafficPropertyOptions(),
      ladderFeeEnabled: false,
      ladderFeeTiers: [],
      loadingBaseProducts: false,
      baseCarrierProductOptions: []
    }
  },
  computed: {
    isShow: {
      get() {
        return this.visible
      },
      set(val) {
        this.$emit('update:visible', val)
      }
    },

    // 后向流量池：套餐价固定为 0，不可改
    isBackward() {
      return this.trafficShareProperty === 'backward'
    },

    priceDisabled() {
      return this.ladderFeeEnabled || this.isBackward
    },

    // 套餐价格 输入框后的单位
    priceLabelUint() {
      return this.isBackward ? '元/GB' : '元'
    },

    // 超额资费 输入框后的单位
    excessPriceQuantityLabelUnit() {
      return this.capacityUnit === 'count' ? '次' : 'MB'
    },

    priceRules() {
      if (this.priceDisabled) {
        return []
      }
      return [{ required: true, message: '请输入套餐价格' }]
    },

    excessPriceRules() {
      if (this.ladderFeeEnabled) {
        return []
      }
      return [{ required: true, message: '请输入超额资费' }]
    },

    excessPriceQuantityRules() {
      if (this.ladderFeeEnabled) {
        return []
      }
      return [{ required: true, message: '请输入超额资费' }]
    },

    // 服务周期存值 1 表示 1 个自然月；容量单位 mb、gb 表示流量
    canEnableLadderFee() {
      return this.serviceCycle === 1 && (this.capacityUnit === 'mb' || this.capacityUnit === 'gb')
    }
  },
  created() {
    this.fetchFormData()
  },
  methods: {
    fetchFormData() {
      findCarrierProductForm(this.id).then((res) => {
        this.data = res.data
        this.applyBaseCarrierProduct({
          capacity_unit: res.data.capacity_unit,
          service_cycle_value: res.data.service_cycle,
          traffic_share_property_slug: res.data.traffic_share_property,
          tags: res.data.tags_display,
          traffic_share_property: res.data.traffic_share_property_display,
          service_cycle: res.data.service_cycle_display,
          package_capacity: res.data.package_capacity_display,
          voice_capacity: res.data.voice_capacity_display
        })
        const trafficProperty = res.data.traffic_property === 'pending' ? undefined : res.data.traffic_property
        // 后向流量池套餐价格固定为 0
        const price = this.trafficShareProperty === 'backward'
          ? 0
          : (res.data.price === -1 ? undefined : res.data.price)
        const excessPrice = res.data.excess_price === -1 ? undefined : res.data.excess_price
        const excessPriceQuantity = res.data.excess_price_quantity === -1 ? undefined : res.data.excess_price_quantity
        this.form.setFieldsValue({
          name: res.data.name,
          base_carrier_product_id: res.data.base_carrier_product_id,
          carrier_package_id: res.data.carrier_package_id,
          price: price,
          excess_price: excessPrice,
          excess_price_quantity: excessPriceQuantity,
          monthly_feature_fee: res.data.monthly_feature_fee == null ? 0 : res.data.monthly_feature_fee,
          gre_price: res.data.gre_price == null ? 0 : res.data.gre_price,
          voice_unit_price: res.data.voice_unit_price == null ? 0 : res.data.voice_unit_price,
          sms_unit_price: res.data.sms_unit_price == null ? 0 : res.data.sms_unit_price,
          traffic_property: trafficProperty,
          description: res.data.description
        })
        this.fetchBaseCarrierProducts(res.data)
        const canEnableLadderFee = res.data.service_cycle === 1 && (res.data.capacity_unit === 'mb' || res.data.capacity_unit === 'gb')
        this.ladderFeeEnabled = canEnableLadderFee && !!res.data.ladder_fee_enabled
        const tiers = res.data.ladder_fee_tiers || []
        this.ladderFeeTiers = tiers.map((tier) => ({
          upper_mb: tier.upper_mb == null ? undefined : tier.upper_mb,
          unit_price: tier.unit_price == null ? 0 : tier.unit_price
        }))
      })
    },

    fetchBaseCarrierProducts(formData) {
      this.loadingBaseProducts = true
      findCarrierType(this.carrierAccountId).then((typeRes) => {
        if (typeRes.code !== 0) {
          this.loadingBaseProducts = false
          return
        }
        return findImportableBaseCarrierProducts({
          carrier_type: typeRes.data.carrier_type
        }).then((res) => {
          const options = res.data || []
          const currentId = formData.base_carrier_product_id
          if (currentId && !options.some((item) => item.id === currentId)) {
            options.unshift({
              id: currentId,
              name: formData.base_carrier_product_name,
              tags: formData.tags_display,
              traffic_share_property: formData.traffic_share_property_display,
              traffic_share_property_slug: formData.traffic_share_property,
              service_cycle: formData.service_cycle_display,
              service_cycle_value: formData.service_cycle,
              package_capacity: formData.package_capacity_display,
              voice_capacity: formData.voice_capacity_display,
              capacity_unit: formData.capacity_unit
            })
          }
          this.baseCarrierProductOptions = options
          this.loadingBaseProducts = false
        })
      }).catch(() => {
        this.loadingBaseProducts = false
      })
    },

    changeBaseCarrierProduct(id) {
      const option = this.baseCarrierProductOptions.find((item) => item.id === id)
      if (!option) {
        return
      }
      this.applyBaseCarrierProduct(option)
      if (!this.canEnableLadderFee && this.ladderFeeEnabled) {
        this.ladderFeeEnabled = false
      }
      if (this.isBackward) {
        this.form.setFieldsValue({ price: 0 })
      }
    },

    applyBaseCarrierProduct(option) {
      this.capacityUnit = option.capacity_unit
      this.serviceCycle = option.service_cycle_value
      this.trafficShareProperty = option.traffic_share_property_slug
      this.data = Object.assign({}, this.data, {
        tags_display: option.tags,
        traffic_share_property: option.traffic_share_property_slug,
        traffic_share_property_display: option.traffic_share_property,
        service_cycle_display: option.service_cycle,
        package_capacity_display: option.package_capacity,
        voice_capacity_display: option.voice_capacity
      })
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },

    changeLadderFeeEnabled(e) {
      if (e.target.checked && !this.canEnableLadderFee) {
        return
      }
      this.ladderFeeEnabled = e.target.checked
      if (this.ladderFeeEnabled && this.ladderFeeTiers.length === 0) {
        this.addLadderTier()
      }
    },

    addLadderTier() {
      this.ladderFeeTiers.push({ upper_mb: undefined, unit_price: 0 })
    },

    removeLadderTier(index) {
      this.ladderFeeTiers.splice(index, 1)
    },

    ladderFeePayload() {
      return this.ladderFeeTiers.map((tier) => ({
        upper_mb: tier.upper_mb == null || tier.upper_mb === '' ? 0 : tier.upper_mb,
        unit_price: tier.unit_price == null ? 0 : tier.unit_price
      }))
    },

    validateLadderFee() {
      if (!this.ladderFeeEnabled) {
        return ''
      }
      if (this.ladderFeeTiers.length === 0) {
        return '启用阶梯资费后请至少配置一档'
      }
      let prevUpper = null
      for (let i = 0; i < this.ladderFeeTiers.length; i++) {
        const tier = this.ladderFeeTiers[i]
        const isLast = i === this.ladderFeeTiers.length - 1
        if (tier.unit_price == null || tier.unit_price < 0) {
          return `请填写档位${i + 1}资费`
        }
        if (tier.upper_mb == null || tier.upper_mb === '') {
          return `请填写档位${i + 1}用量`
        }
        if (tier.upper_mb <= 0) {
          return `档位${i + 1}用量须大于0`
        }
        if (prevUpper != null) {
          if (isLast && tier.upper_mb < prevUpper) {
            return '最后一档用量须不小于上一档'
          }
          if (!isLast && tier.upper_mb <= prevUpper) {
            return '档位用量须递增'
          }
        }
        prevUpper = tier.upper_mb
      }
      return ''
    },

    handleSubmit(e) {
      e.preventDefault()
      if (this.submitting) {
        this.$warning({
          title: '请勿重复提交',
          content: ''
        })
        return
      }

      this.form.validateFields((err, values) => {
        if (!err) {
          const ladderError = this.validateLadderFee()
          if (ladderError) {
            this.$error({
              title: '提示',
              content: ladderError
            })
            return
          }
          this.submitting = true
          const data = Object.assign({ carrier_account_id: this.carrierAccountId }, values, {
            price: this.isBackward ? 0 : values.price,
            monthly_feature_fee: values.monthly_feature_fee == null ? 0 : values.monthly_feature_fee,
            gre_price: values.gre_price == null ? 0 : values.gre_price,
            voice_unit_price: values.voice_unit_price == null ? 0 : values.voice_unit_price,
            sms_unit_price: values.sms_unit_price == null ? 0 : values.sms_unit_price,
            ladder_fee_enabled: this.ladderFeeEnabled,
            ladder_fee_tiers: this.ladderFeePayload()
          })
          updateCarrierProduct(this.id, data).then((res) => {
            if (res.code === 0) {
              // 关闭模态框
              this.isShow = false
              // 告知父组件已完成
              this.$emit('completed')
            }
            this.submitting = false
          })
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.item-title {
  display: block;
  color: @primary-color;
  font-weight: 600;
  margin-bottom: 8px;
}

.ladder-fee-hint {
  color: rgba(0, 0, 0, 0.45);
}

.field-disabled-text {
  color: rgba(0, 0, 0, 0.25);
}
</style>
